(() => {
  const init = () => {
    const dialog = document.getElementById('mt-garage-dialog');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const slot = dialog.querySelector('[data-mt-garage-content]');
    const status = dialog.querySelector('[data-mt-garage-status]');
    const fallback = dialog.querySelector('[data-mt-garage-fallback]');
    const message = dialog.querySelector('[data-mt-garage-message]');
    const loadingText = message.textContent;
    let nativeWidget;
    let nativeObserver;
    let opener;
    let previousOverflow;
    let waitTimer;
    let hasOpenedNative = false;
    document.body.dataset.mtGarageEnabled = 'true';
    const syncButtons = open => {
      document.querySelectorAll('[data-mt-garage-open]').forEach(button => button.setAttribute('aria-expanded', String(open)));
    };
    const close = () => {
      clearTimeout(waitTimer);
      if (nativeWidget?.classList.contains('easysearch-garage-opened')) nativeWidget.querySelector('.easysearch-garage-btn-close')?.click();
      if (dialog.open) dialog.close();
    };
    const isReady = () => nativeWidget?.isConnected && !nativeWidget.classList.contains('easysearch-hidden') && nativeWidget.querySelector('.easysearch-garage-btn-open');
    const openNative = () => {
      if (!dialog.open || !isReady()) return false;
      status.hidden = true;
      fallback.hidden = true;
      if (!nativeWidget.classList.contains('easysearch-garage-opened')) nativeWidget.querySelector('.easysearch-garage-btn-open').click();
      hasOpenedNative = nativeWidget.classList.contains('easysearch-garage-opened');
      return true;
    };
    const bindNative = () => {
      const widget = document.querySelector('.easysearch-garage-widget');
      if (!widget || widget.classList.contains('easysearch-hidden')) return;
      if (nativeWidget !== widget) {
        nativeObserver?.disconnect();
        nativeWidget = widget;
        widget.dataset.mtGarageNative = 'true';
        slot.replaceChildren(widget);
        nativeObserver = new MutationObserver(() => {
          if (!dialog.open) return;
          if (hasOpenedNative && !widget.classList.contains('easysearch-garage-opened')) close();
          else if (!hasOpenedNative) openNative();
        });
        nativeObserver.observe(widget, {attributes: true, attributeFilter: ['class']});
      }
      openNative();
    };
    const beginLoading = () => {
      clearTimeout(waitTimer);
      hasOpenedNative = false;
      message.textContent = loadingText;
      status.querySelector('.mt-garage-loader').hidden = false;
      status.hidden = false;
      fallback.hidden = true;
      bindNative();
      if (!openNative()) waitTimer = setTimeout(() => {
        if (!dialog.open || openNative()) return;
        message.textContent = dialog.dataset.unavailable;
        status.querySelector('.mt-garage-loader').hidden = true;
        fallback.hidden = false;
      }, 8000);
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-mt-garage-open]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        if (dialog.open) return;
        opener = trigger;
        previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        syncButtons(true);
        dialog.querySelector('[data-mt-garage-close]').focus();
        beginLoading();
      }
      if (dialog.open && event.target !== dialog && dialog.contains(event.target) && !nativeWidget?.contains(event.target)) event.stopPropagation();
      if (event.target.closest('[data-mt-garage-close]')) close();
      if (event.target.closest('[data-mt-garage-retry]')) {
        status.querySelector('.mt-garage-loader').hidden = false;
        beginLoading();
      }
    }, true);
    dialog.addEventListener('cancel', event => {event.preventDefault();close();});
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex]')].filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first) {event.preventDefault();return;}
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    });
    document.addEventListener('focusin', event => {
      if (dialog.open && !dialog.contains(event.target)) dialog.querySelector('[data-mt-garage-close]').focus();
    }, true);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      event.stopPropagation();
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', () => {
      clearTimeout(waitTimer);
      hasOpenedNative = false;
      document.body.style.overflow = previousOverflow || '';
      syncButtons(false);
      opener?.focus();
    });
    bindNative();
    new MutationObserver(bindNative).observe(document.body, {childList: true, subtree: true});
    document.addEventListener('easysearch_ready', bindNative);
    document.addEventListener('easysearch_garage_rendered', bindNative);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
